import { LIST, linkNode } from "./common";
import { ELEMENT_TRANSFORMERS } from "./markdown-element-transformers";

import type { TextFormatTransformer, Transformer } from "@lexical/markdown";

const SLACK_BOLD_STAR: TextFormatTransformer = {
  format: ["bold"],
  // The tag is surrounded by a zero-width space to work better with slack
  tag: "\u200B*\u200B",
  type: "text-format",
};

const SLACK_ITALIC_UNDERSCORE: TextFormatTransformer = {
  format: ["italic"],
  intraword: false,
  // The tag is surrounded by a zero-width space to work better with slack
  tag: "\u200B_\u200B",
  type: "text-format",
};

export const SlackMrkDwnTransformers: Transformer[] = [
  SLACK_BOLD_STAR,
  SLACK_ITALIC_UNDERSCORE,
  LIST("• "),
  linkNode((text, url) => `<${url}|${text}>`),
  ...ELEMENT_TRANSFORMERS("slack"),
];
